module.exports = "/assets/b66c5a2785814fe199fa71de88cbbba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8E.png
// module id = 2262
// module chunks = 0